const pushArraybuffer2Client = (res, filename) => {
    if (res !== null && res !== '') {
        const url = window.URL.createObjectURL(new Blob([res]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename) //or any other extension
        document.body.appendChild(link)
        link.click()
    }

}
export {pushArraybuffer2Client}
